export default {
  state: [
    {},
    {
      name: 'Name',
      phone: 'Phone',
      email: 'Email',
      sms: 'Sms',
      gender: 'Gender',
      birthday: 'Birthday',
      code: 'Code',
      enter_code: 'Enter the code',
      register: 'Register',
      sign_up: 'Sign Up',
      register_p: 'Please sign up in order to connect to Free Wi-Fi',
      gift_p: 'Please sign up in order to get your Free Gift',
      gift: 'Gift',
      registerForFullTime: 'Register for full time Internet',
      verify: 'Verify',
      verification: 'Verification',
      company: 'Company',
      companyPosts: 'More posts from this Company',
      relatedPosts: 'Related Posts',
      activePosts: 'Active Posts',
      savedPosts: 'Saved Posts',
      relatedPostsText: 'You may also like to see this posts',
      home: 'Back to Home',
      or: 'Or',
      in: 'In',
      tags: 'Tags',
      male: 'Male',
      female: 'Female',
      other: 'Custom',
      name_ph: 'Enter your name',
      email_ph: 'Enter your email',
      phone_ph: 'Enter your phone',
      search_ph: 'Search',
      birthday_ph: 'Enter your birthday',
      facebook_sign_up: 'Sign Up with Facebook',
      twitter_sign_up: 'Sign Up with Twitter',
      linkedin_sign_up: 'Sign Up with LinkedIn',
      google_sign_up: 'Sign Up with Google',
      email_sign_up: 'Sign Up with Email',
      sms_sign_up: 'Sign Up with SMS',
      whatsapp_sign_up: 'Sign Up with WhatsApp',
      sign_up_agree: 'By clicking "Sign up" I agree to',
      terms: 'Terms & Conditions and Privacy Policy',
      skip_p: 'Prefer without sign up?',
      skip: 'Than skip registration',
      skipText: 'Without account you will have 30 minutes of Free Internet.',
      pleaseWait: 'Please Wait',
      seconds: 'seconds',
      connecting: 'Connecting',
      connected: 'Connected',
      about: 'About',
      location: 'Location',
      wrong_number: 'If you entered the wrong phone number',
      wrong_email: 'If you entered the wrong email',
      click_here: 'please click here',
      email_verify: 'Please verify your email address!',
      form_alert: 'Please enter your ',
      max_devices: 'You have already registered max number of devices.',
      waitSecond: 'Please, wait a second',
      allRightsReserved: 'All rights reserved',
      personal: 'Personal',
      settings: 'Settings',
      subscriptions: 'Subscriptions',
      beforeDelete: 'Before deleting account please read ',
      dangerZone: 'Danger zone',
      deleteAccount: 'Delete Account',
      WRONG_CODE: 'Wrong code',
      INVALID_EMAIL: 'Invalid email',
      ERROR: 'Error occurs. Please contact support. support@alideda.com',
      fb_permissions: 'Not all permissions granted! Please sign up again properly!',
      rating: 'Rating',
      write_review: 'Tap a star to rate us',
      share_with_others: 'Can you share your opinion with others?😊',
      google_review: 'Google Review',
      facebook_review: 'Facebook Review',
      tripadvisor_review: 'TripAdvisor Review',
      review_placeholder: 'Share details of you own experience at this place!',
      review_thanks: 'Thank you for rating us!',
      submit: 'Submit',
      language: {
        english: 'English',
        german: 'German',
        serbian: 'Serbian'
      },
      verify_txt: {
        'email': {
          wifi_text: '<b>You have 5 minutes to verify your email address.</b> <br><br> After verification you will become full time of internet connection. <br><br> <span class="color-red-dark"><b>In case you don\'t verify your email address, you will be disconnected from Wi-Fi network!</b></span>',
          wifi_subtitle: 'Verification link is sent to',
          gift_text: '<br><b>You\'re one step away from surprise<br><br>Check your inbox 🎁🤩</b>',
          gift_subtitle: 'Gift has been sent to',
          link: 'If you entered a wrong email',
          button: 'Verify Email'
        },
        'sms': {
          wifi_text: '',
          wifi_subtitle: 'Verification code was sent to',
          gift_text: '',
          gift_subtitle: 'Verification code was sent to',
          link: 'If you entered a wrong number',
          button: 'Verify code'
        },
        'whatsapp': {
          wifi_text: '',
          wifi_subtitle: 'Verification code was sent to',
          gift_text: '',
          gift_subtitle: 'Verification code was sent to',
          link: 'If you entered a wrong number',
          button: 'Verify code'
        },
        'code': {
          text: '',
          subtitle: 'Verification...',
          link: 'If you entered a wrong number',
          button: 'Verification...'
        }
      }
    },
    {
      name: 'Name',
      phone: 'Handynummer',
      email: 'Email',
      sms: 'Sms',
      gender: 'Geschlecht',
      birthday: 'Geburtstag',
      code: 'Code',
      enter_code: 'Code Eintippen',
      register: 'Einloggen',
      sign_up: 'Einloggen',
      register_p: 'Bitte loggen Sie sich ein, um Free Wi-Fi zu benutzen',
      gift_p: 'Bitte loggen Sie sich ein, um ein Geschenk zu bekommen',
      gift: 'Geschenk',
      registerForFullTime: 'Einloggen für volle Internetzeit',
      verify: 'Verifizieren',
      verification: 'Verifizierung',
      company: 'Firma',
      companyPosts: 'Mehr Werbungen dieser Firma',
      relatedPosts: 'Ähnliche Werbungen',
      activePosts: 'Aktive Werbungen',
      savedPosts: 'Gemerkte Werbungen',
      relatedPostsText: 'Sie möchten auch diese Werbungen zu sehen',
      home: 'Zurück zum Anfang',
      or: 'Oder',
      in: 'In',
      tags: 'Tags',
      male: 'Männlich',
      female: 'Weiblich',
      other: 'Divers',
      name_ph: 'Name eintippen',
      email_ph: 'Email eintippen',
      phone_ph: 'Handynummer eintippen',
      search_ph: 'Suchen',
      birthday_ph: 'Geburtstag eintippen',
      facebook_sign_up: 'Mit Facebook einloggen',
      twitter_sign_up: 'Mit Twitter einloggen',
      linkedin_sign_up: 'Mit LinkedIn einloggen',
      google_sign_up: 'Mit Google einloggen',
      email_sign_up: 'Mit Email einloggen',
      sms_sign_up: 'Mit SMS einloggen',
      whatsapp_sign_up: 'Mit WhatsApp einloggen',
      sign_up_agree: 'Durch Klicken auf "Einloggen" stimme ich zu',
      terms: 'AGBs und Datenschutzbestimmungen',
      skip_p: 'Lieber ohne registrieren?',
      skip: 'Dann einfach überspringen',
      skipText: 'Ohne Konto haben Sie 30 Minuten frei Internetverbindung.',
      pleaseWait: 'Bitte warten',
      seconds: 'Sekunden',
      connecting: 'Verbinden',
      connected: 'Verbunden',
      about: 'Über',
      location: 'Adresse',
      wrong_number: 'Wenn Sie falsche Handynummer eingegeben haben',
      wrong_email: 'Wenn Sie falsche Email eingegeben haben',
      click_here: 'bitte hier klicken',
      email_verify: 'Bitte verifizieren Sie ihre Email Adresse',
      form_alert: 'Bitte geben Sie Ihre ',
      max_devices: 'Sie haben die maximale Anzahl an Geräten bereits registriert.',
      waitSecond: 'Bitte warten Sie eine Sekunde',
      allRightsReserved: 'Alle Rechte vorbehalten',
      personal: 'Persönlich',
      settings: 'Einstellungen',
      subscriptions: 'Abonnements',
      beforeDelete: 'Bevor Sie das Konto löschen, lesen Sie bitte ',
      dangerZone: 'Gefahrenzone',
      deleteAccount: 'Konto löschen',
      WRONG_CODE: 'Falsches code',
      INVALID_EMAIL: 'Ungültige E-Mail',
      ERROR: 'Fehler aufgetreten. Bitte service zentrum kontaktieren. support@alideda.com',
      fb_permissions: 'Nicht alle Berechtigungen erteilt! Bitte melden Sie sich wieder richtig an!',
      rating: 'Bewertung',
      write_review: 'Tippe auf einen Stern, um uns zu bewerten',
      share_with_others: 'Können Sie Ihre Meinung mit anderen teilen?😊',
      google_review: 'Google Bewertung',
      facebook_review: 'Facebook Bewertung',
      tripadvisor_review: 'TripAdvisor Bewertung',
      review_placeholder: 'Teilen Sie Details Ihrer eigenen Erfahrung an diesem Ort!',
      review_thanks: 'Vielen Dank, dass Sie uns bewertet haben!',
      submit: 'Abschicken',
      language: {
        english: 'Englisch',
        german: 'Deutsch',
        serbian: 'Serbisch'
      },
      verify_txt: {
        'email': {
          wifi_text: '<b>Sie haben 5 Minuten Zeit, Ihre Email Adresse zu bestätigen.</b> <br><br>Erst nach der Bestätigung bekommen Sie volle Internetverbindung. <br><br> <span class="color-red-dark"><b>Falls Sie Ihre E-Mail Adresse nicht bestätigen, werden Sie vom WLAN Netzwerk getrennt!</b></span>',
          wifi_subtitle: 'Bestätigungslink wurde gesendet an',
          gift_text: '<br><b>Noch ein Schritt zu Ihrer Überraschung<br><br>Überprüfe den Posteingang 🎁🤩</b>',
          gift_subtitle: 'Geschenk wurde gesendet an',
          link: 'Falls Sie falsche Email eingegeben haben',
          button: 'Email Bestätigen'
        },
        'sms': {
          wifi_text: '',
          wifi_subtitle: 'Bestätigungscode wurde geschickt an',
          gift_text: '',
          gift_subtitle: 'Bestätigungscode wurde geschickt an',
          link: 'Falls Sie falsche Handynummer eingegeben haben',
          button: 'Code Bestätigen'
        },
        'whatsapp': {
          wifi_text: '',
          wifi_subtitle: 'Bestätigungscode wurde geschickt an',
          gift_text: '',
          gift_subtitle: 'Bestätigungscode wurde geschickt an',
          link: 'Falls Sie falsche Handynummer eingegeben haben',
          button: 'Code Bestätigen'
        },
        'code': {
          text: '',
          subtitle: 'Überprüfen...',
          link: 'Wenn Sie falsche Handynummer eingegeben haben',
          button: 'Überprüfen...'
        }
      }
    },
    { // č ć ž đ š
      name: 'Ime',
      phone: 'Broj telefona',
      email: 'Email',
      sms: 'Sms',
      gender: 'Pol',
      birthday: 'Rođendan',
      code: 'Kod',
      enter_code: 'Unesite kod',
      register: 'Registrujte se',
      sign_up: 'Registracija',
      register_p: 'Molimo Vas registrujte se da biste slobodno koristili Wi-Fi mrežu',
      gift_p: 'Molimo Vas registrujte se da biste dobili poklon',
      gift: 'Poklon',
      registerForFullTime: 'Registrujte se za punu Internet konekciju',
      verify: 'Verifikacija',
      verification: 'Verifikacija',
      company: 'Firma',
      companyPosts: 'Više reklama ove Firme',
      relatedPosts: 'Slične reklame',
      activePosts: 'Aktivne reklame',
      savedPosts: 'Sacuvane reklame',
      relatedPostsText: 'Možda želite videti i ove reklame',
      home: 'Nazad na start',
      or: 'Ili',
      in: 'U',
      tags: 'Tagovi',
      male: 'Muško',
      female: 'Žensko',
      other: 'Neodređen',
      name_ph: 'Unesite vaše ime',
      email_ph: 'Unesite vaš email',
      phone_ph: 'Unesite vaš broj',
      search_ph: 'Pretražite',
      birthday_ph: 'Unesite vaš rođendan',
      facebook_sign_up: 'Facebook Registracija',
      twitter_sign_up: 'Twitter Registracija',
      linkedin_sign_up: 'LinkedIn Registracija',
      google_sign_up: 'Google Registracija',
      email_sign_up: 'Email Registracija',
      sms_sign_up: 'SMS Registracija',
      whatsapp_sign_up: 'WhatsApp Registracija',
      sign_up_agree: 'Prilikom registrovanja potvrđujem',
      terms: 'Uslove korišćenja i politiku privatnosti',
      skip_p: 'Radije bez registracije?',
      skip: 'Onda preskočite',
      skipText: 'Bez registracije imate 30 minuta slobodne Internet konekcije',
      pleaseWait: 'Molimo sačekajte',
      seconds: 'sekunde',
      connecting: 'Povezivanje...',
      connected: 'Povezano',
      about: 'Opis',
      location: 'Lokacija',
      wrong_number: 'Ako ste uneli pogrešan broj telefona',
      wrong_email: 'Ako ste uneli pogrešnu Email adresu',
      click_here: 'molimo kliknite ovde',
      email_verify: 'Molimo potvrdite vašu Email adresu',
      form_alert: 'Molimo unesite ',
      max_devices: 'Već ste iskoristili maksimalan broj uređaja ovom metodom.',
      waitSecond: 'Molimo sačekajte trenutak',
      allRightsReserved: 'Sva prava zadržana',
      personal: 'Lični podaci',
      settings: 'Podešavanja',
      subscriptions: 'Pretplatnici',
      beforeDelete: 'Pre nego što obrišete nalog, pročitajte ',
      dangerZone: 'Opasna zona',
      deleteAccount: 'Obriši nalog',
      WRONG_CODE: 'Pogrešan kod',
      INVALID_EMAIL: 'Email nije validan',
      ERROR: 'Desila se greška. Molimo kontaktirajte servis centar. support@alideda.com',
      fb_permissions: 'Nisu odobrene sve dozvole! Molimo da se prijavite ponovo!',
      rating: 'Ocena',
      write_review: 'Kliknite na zvezdu da biste nas ocenili',
      share_with_others: 'Možete li svoje mišljenje podeliti sa drugima?😊',
      google_review: 'Google Recenzija',
      facebook_review: 'Facebook Recenzija',
      tripadvisor_review: 'TripAdvisor Recenzija',
      review_placeholder: 'Podelite svoje iskustvo sa ovog mesta!',
      review_thanks: 'Hvala što ste nas ocenili!',
      submit: 'Pošalji',
      language: {
        english: 'Engleski',
        german: 'Nemački',
        serbian: 'Srpski'
      },
      verify_txt: {
        'email': {
          wifi_text: '<b>Imate 5 minuta da potvrdite vašu Email adresu.</b><br><br> Nakon potvrde moći ćete da koristite puno vreme internet konekcije. <br><br> <span class="color-red-dark"><b>Ukoliko ne potvrdite vašu Email adresu, bićete diskonektovani sa Wi-Fi mreže!</b></span>',
          wifi_subtitle: 'Verifikacioni link je poslat na',
          gift_text: '<br><b>Na korak ste od iznenađenja<br><br>Proverite svoj inbox 🎁🤩</b>',
          gift_subtitle: 'Poklon je poslat na',
          link: 'Ukoliko ste uneli pogrešnu Email adresu',
          button: 'Potvrdi Email'
        },
        'sms': {
          wifi_text: '',
          wifi_subtitle: 'Verifikacioni kod je poslat na',
          gift_text: '',
          gift_subtitle: 'Verifikacioni kod je poslat na',
          link: 'Ukoliko ste uneli pogrešan broj telefona',
          button: 'Proveri kod'
        },
        'whatsapp': {
          wifi_text: '',
          wifi_subtitle: 'Verifikacioni kod je poslat na',
          gift_text: '',
          gift_subtitle: 'Verifikacioni kod je poslat na',
          link: 'Ukoliko ste uneli pogrešan broj telefona',
          button: 'Proveri kod'
        },
        'code': {
          wifi_text: '',
          wifi_subtitle: 'Verifikacija...',
          link: 'Ukoliko ste uneli pogrešan broj telefona',
          button: 'Verifikacija...'
        }
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/lang.js